/* global dataLayer, _cc10461, Sailthru */

export function setPageTitleInDataLayer() {
  if (document.title.indexOf(" - Axios") > 0) {
    const slicedTitle = document.title.slice(
      0,
      document.title.indexOf(" - Axios")
    );
    dataLayer.push({ title: slicedTitle });
  }
}

export function setUserInDataLayer(id) {
  dataLayer.push({ "userID Data Layer Var": id });
}

export function trackPageView() {
  dataLayer.push({
    Card: false,
    event: "GA_Virtual_Pageviews_Event",
  });
}

export function trackCardViewedInStream({ story, stream, featured, position }) {
  dataLayer.push({
    "Stream Lookup": stream.lookup,
    "Stream Type": stream.type,
    "Stream Display Name": stream.displayName,
    Headline: story.headline,
    Authors:
      story.authors &&
      story.authors.map(author => author.display_name).join("|"),
    Editors:
      story.editors &&
      story.editors.map(editor => editor.display_name).join("|"),
    "Published Date": story.published_date,
    "Primary Section": story.primary_section && story.primary_section.name,
    Sections:
      story.sections && story.sections.map(section => section.name).join("|"),
    "Primary Tag": story.primary_tag && story.primary_tag.name,
    Tags: story.tags && story.tags.map(tag => tag.name).join("|"),
    "Post ID": story.id,
    Card: true,
    "Card Count": 1,
    Rubric: story.rubric && story.rubric.name,
    Featured: featured,
    Position: position + 1,
    event: "GA_Virtual_Pageviews_Event",
  });

  // Lotame
  const sections =
    story.primary_section && story.primary_section.name
      ? [story.primary_section, ...story.sections]
      : story.sections;
  const tags =
    story.primary_tag && story.primary_tag.name
      ? [story.primary_tag, ...story.tags]
      : story.tags;

  const postAttributes =
    sections && tags
      ? [...sections, ...tags]
          .map(obj => obj.name)
          .join()
          .replace(/ /g, "_")
      : "";

  if (typeof _cc10461 !== "undefined") {
    _cc10461.bcpw("int", postAttributes, "act", postAttributes);
  }

  // Sailthru
  typeof Sailthru !== "undefined" &&
    Sailthru.track("pageview", {
      url: story.permalink,
    });
}
